import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import React from 'react';
import SearchStore from 'stores/SearchStore';
import SearchInputBox from './SearchInputBox';
import SearchFieldsActionStore from 'stores/search/SearchFieldsActionStore';
import SearchInputActions from 'actions/search/SearchInputActions';

/**
 * `SearchInputBoxContainer` is a `AltContainer` component for the `SearchInputBox`
 * component within the `CallsComponent`
 */
class SearchInputBoxContainer extends React.Component {
  static getStores() {
    return [SearchFieldsActionStore, SearchStore];
  }

  static getPropsFromStores() {
    const searchTerm = SearchStore.getState().get('searchTerm');
    const menuItemsStatus = SearchFieldsActionStore.getState().get('menuItemsStatus');
    const shouldClearSearchTerm = SearchFieldsActionStore.getState().get('shouldClearSearchTerm');
    const searchType = SearchStore.getState().get('searchType');
    return {
      menuItemsStatus: menuItemsStatus,
      searchTerm: searchTerm,
      shouldClearSearchTerm: shouldClearSearchTerm,
      searchType: searchType,
    };
  }

  render() {
    return (
      <AltContainer
        actions={{
          SearchInputActions: SearchInputActions,
        }}>
        <SearchInputBox onChange={this.props.searchTermChanged} {...this.props} />
      </AltContainer>
    );
  }
}

export default connectToStores(SearchInputBoxContainer);
